import { useState } from "react";
import { useApi, CATEGORIES, catLabel } from "../lib/api";
import { MaskLines, Reveal } from "../components/Reveal";
import { WebPickCard } from "../components/WebPickCard";
import { Seo } from "../components/Seo";

export default function FromTheWebPage() {
  const [cat, setCat] = useState("");
  const { data, isLoading } = useApi("/from-the-web");
  const all = Array.isArray(data?.items) ? data.items : [];
  const items = cat ? all.filter((i) => i.category === cat) : all;

  return (
    <main className="pt-32 pb-24 max-w-[1440px] mx-auto px-5 sm:px-10" data-testid="from-the-web-page">
      <Seo
        title="From the Web — Youth Culture Reading List | YOUTH"
        description="Our pick of youth culture stories from around the web: fashion, culture, art and beauty headlines with short notes written by the YOUTH team."
        path="/from-the-web"
      />
      <p className="kicker text-rose">Elsewhere · {all.length} picks</p>
      <h1 className="display text-[16vw] sm:text-[11vw] lg:text-[8vw] leading-[0.88] mt-3">
        <MaskLines lines={["From", "the Web"]} />
      </h1>
      <p className="font-serif italic text-xl sm:text-2xl text-ink/75 max-w-2xl mt-6">
        Our pick of stories from Youth Magazine (ymagazine.com). Headlines and links go to the original articles; the short notes are ours.
      </p>
      <div className="flex flex-wrap gap-2 mt-10" data-testid="web-filter">
        {["", ...CATEGORIES.filter((c) => c !== "riot")].map((c) => (
          <button
            key={c || "all"}
            onClick={() => setCat(c)}
            className={`kicker rounded-full px-4 py-2 border transition-colors ${cat === c ? "bg-ink text-cream border-ink" : "border-ink/25 hover:border-ink hover:bg-ink/5"}`}
            data-testid={`web-filter-${c || "all"}`}
          >
            {catLabel(c) || "all"}
          </button>
        ))}
      </div>
      {isLoading && <p className="kicker mt-12">Loading…</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4 mt-12">
        {items.map((it, i) => (
          <Reveal key={it.url} delay={(i % 3) * 0.06} className="h-full">
            <WebPickCard item={it} index={i} testId={`web-page-pick-${i}`} />
          </Reveal>
        ))}
      </div>
      {!isLoading && !items.length && <p className="font-serif italic text-2xl mt-12" data-testid="web-empty">No picks in this section yet.</p>}
    </main>
  );
}
